/**
 * Mobile navigation toggle (progressive enhancement).
 *
 * The header partial (src/partials/nav.html) renders a `[data-nav-toggle]`
 * button — hidden at md: and up — and the `#site-nav-menu` list, hidden on
 * small screens until toggled. Without JS the menu button does nothing, but
 * every destination stays reachable through the footer links, so the site
 * degrades gracefully.
 */
export function initNavToggle(doc: Document): void {
  const button = doc.querySelector<HTMLButtonElement>("[data-nav-toggle]");
  const menu = doc.getElementById("site-nav-menu");
  if (!button || !menu) return;

  button.addEventListener("click", () => {
    const expanded = button.getAttribute("aria-expanded") === "true";
    button.setAttribute("aria-expanded", String(!expanded));
    menu.classList.toggle("hidden", expanded);
  });
}
